import stockSummaryMdl from "./stockSummary.mdl";

export default [...stockSummaryMdl];
